import { Component, ElementRef, OnInit } from '@angular/core';
import { ApiService } from "../../api.service";

@Component({
  selector: 'app-newmasivadownload',
  templateUrl: './newmasivadownload.page.html',
  styleUrls: ['./newmasivadownload.page.scss'],
})
export class NewmasivadownloadPage implements OnInit {

  constructor(
    public api:ApiService
  ) { }

  ngOnInit() {
  }

}
